module.exports = __webpack_public_path__ + "static/media/logo-iplayme2.424c2755.svg";